<template>
  <UiIconButton
    type="button"
    class="ui-hamburger"
    variant="secondary"
    size="md"
    :class="[isLight ? 'ui-hamburger--light' : 'ui-hamburger--dark', isOpen && 'ui-hamburger--open']"
    :aria-expanded="isOpen"
    aria-controls="mobile-menu"
    @click="emit('toggle')"
  >
    <span class="ui-hamburger__sr-only">{{ label }}</span>
    <Menu
      :size="24"
      :stroke-width="2"
      aria-hidden="true"
      class="ui-hamburger__icon"
    />
  </UiIconButton>
</template>

<script setup lang="ts">
import { Menu } from 'lucide-vue-next';
import UiIconButton from './UiIconButton.vue';

const { isLight, isOpen, label = 'Открыть меню' } = defineProps<{
  isLight: boolean;
  isOpen: boolean;
  label?: string;
}>();

const emit = defineEmits<{ (e: 'toggle'): void }>();
</script>

<style scoped>
.ui-hamburger {
  display: inline-flex;
  color: var(--ui-foreground);
}

@media (min-width: 1024px) {
  .ui-hamburger {
    display: none;
  }
}

.ui-hamburger:hover {
  transform: translateY(-1px);
}

.ui-hamburger--dark {
  border-color: color-mix(in srgb, var(--ui-border) 80%, transparent 20%);
  background: color-mix(in srgb, var(--ui-surface) 75%, transparent 25%);
  box-shadow: var(--ui-control-shadow);
}

.ui-hamburger--open {
  border-color: var(--ui-border-strong);
}

.ui-hamburger__icon {
  transition: color 0.2s ease, opacity 0.2s ease;
  opacity: 0.9;
}

.ui-hamburger--light .ui-hamburger__icon {
  opacity: 0.82;
}

.ui-hamburger--dark .ui-hamburger__icon {
  color: color-mix(in srgb, var(--ui-foreground-inverse) 90%, var(--ui-foreground) 10%);
  opacity: 1;
}

.ui-hamburger__icon {
  width: 1.25rem;
  height: 1.25rem;
  color: currentColor;
}

.ui-hamburger__sr-only {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
</style>
